unable to read source [project]/node_modules/@zxing/src/readers/BrowserCodeReader.ts